import React from 'react';
import { Building2, Plus } from 'lucide-react';

/**
 * Componente para mostrar estado vacío cuando no hay propiedades
 */
const EmptyState = ({ onCreateProperty }) => {
  return (
    <div className="bg-slate-800/50 backdrop-blur-xl rounded-xl p-12 border border-slate-700/50 text-center">
      <Building2 className="w-16 h-16 text-slate-600 mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-white mb-2">No hay propiedades</h3>
      <p className="text-slate-400 mb-6">Crea tu primera propiedad para comenzar</p>
      <button
        onClick={onCreateProperty}
        className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 text-slate-900 font-semibold px-6 py-3 rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all"
      >
        <Plus className="w-5 h-5" />
        Nueva Propiedad
      </button>
    </div>
  );
};

export default EmptyState;